// File: src/utils/chartHelpers.js
import { TIME_PERIODS } from './constants';

export const createChartOptions = (selectedSector, marketData, isDarkMode) => {
  const sectorData = marketData[selectedSector];
  
  if (!sectorData) {
    return null;
  }

  // Convert data into arrays for Chart.js
  const labels = TIME_PERIODS;
  const values = TIME_PERIODS.map(period => sectorData[period] || 0);

  return {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [
        {
          label: 'Performance',
          data: values,
          backgroundColor: values.map(value => 
            value >= 0 ? '#10B981' : '#E02424' // Green for positive, Red for negative
          ),
          borderColor: values.map(value => 
            value >= 0 ? '#10B981' : '#E02424'
          ),
          borderWidth: 1,
          borderRadius: 4,
          borderSkipped: false,
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: `${selectedSector}`,
          font: {
            size: 18,
            weight: 'bold'
          },
          color: isDarkMode ? 'white' : 'black',
          padding: {
            top: 10,
            bottom: 30
          }
        },
        legend: {
          display: false
        },
        tooltip: {
          enabled: false // Disable tooltips like Highcharts version
        },
        // DISABLE the built-in datalabels plugin if it exists
        datalabels: {
          display: false
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          ticks: {
            color: isDarkMode ? 'white' : 'black',
            font: {
              size: 12
            }
          }
        },
        y: {
          position: 'right', // Similar to Highcharts opposite: true
          grid: {
            color: isDarkMode ? '#111827' : '#e5e7eb'
          },
          ticks: {
            color: isDarkMode ? 'white' : 'black',
            font: {
              size: 12
            },
            callback: function(value) {
              return value + '%';
            }
          }
        }
      },
      animation: false, // Disable animations like Highcharts
      elements: {
        bar: {
          borderRadius: 0
        }
      },
      layout: {
        padding: {
          top: 20,
          bottom: 10
        }
      }
    },
    plugins: [
      {
        id: 'customDataLabels',
        afterDatasetsDraw: function(chart) {
          const ctx = chart.ctx;
          
          chart.data.datasets.forEach((dataset, i) => {
            const meta = chart.getDatasetMeta(i);
            
            meta.data.forEach((bar, index) => {
              const dataValue = dataset.data[index];
              
              // Style the text
              ctx.fillStyle = isDarkMode ? 'white' : 'black';
              ctx.font = 'bold 12px Arial';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'bottom';
              
              // Format the number to 2 decimal places with % sign
              const formattedValue = dataValue.toFixed(2) + '%';
              
              // Position the label above the bar
              const yPosition = bar.y - 8; // 8px above the bar
              
              // Draw the text
              ctx.fillText(formattedValue, bar.x, yPosition);
            });
          });
        }
      }
    ]
  };
};